import React, { useContext, useMemo } from "react";
import { Alert, Link as MuiLink, Typography } from "@mui/material";
import {
  BRAND_COLOR,
  GUIDANCE_CALLOUT_PANEL_BG,
  GUIDANCE_CALLOUT_PANEL_BORDER,
  KivuI18nContext,
  localizedPath,
  PAGE_ROUTE_LEARN_MORE_CATEGORIES,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

/**
 * Learn-more ingress at the top of the add-category form.
 */
const AddCategoryGuidanceBanner: React.FC = () => {
  const { t } = useKivunovaTranslation();
  const { language, defaultLang } = useContext(KivuI18nContext) || {};

  const categoriesLearnMorePath = useMemo(
    () =>
      language != null && defaultLang != null
        ? localizedPath(PAGE_ROUTE_LEARN_MORE_CATEGORIES, language, defaultLang)
        : `/${PAGE_ROUTE_LEARN_MORE_CATEGORIES}`,
    [language, defaultLang]
  );

  return (
    <Alert
      severity="info"
      data-testid="add-category-guidance-banner"
      sx={{
        borderRadius: 2,
        alignItems: "flex-start",
        bgcolor: GUIDANCE_CALLOUT_PANEL_BG ?? "#ffffff",
        border: `1px solid ${GUIDANCE_CALLOUT_PANEL_BORDER ?? "#e8f4fc"}`,
        color: "text.secondary",
        "& .MuiAlert-icon": { color: "#0288d1" },
        "& .MuiAlert-message": { width: "100%" }
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {t(
          "add-category-guidance-prefix",
          "Parent categories group your catalog; child categories narrow each group step by step."
        )}{" "}
        <MuiLink
          href={categoriesLearnMorePath}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{
            color: BRAND_COLOR,
            fontWeight: 600,
            "&:hover": { color: BRAND_COLOR }
          }}
          data-testid="add-category-guidance-learn-more-link"
        >
          {t(
            "add-category-guidance-learn-more-link",
            "Learn how categories and subcategories work"
          )}
        </MuiLink>
      </Typography>
    </Alert>
  );
};

export default AddCategoryGuidanceBanner;
